import { Component, OnInit } from '@angular/core';
import { DatePipe, NgForOf, NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { ResAnonymousService } from '../service/ResAnonymous.service';
import { MatStepperModule } from '@angular/material/stepper';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-track-order',
  standalone: true,
  // imports: [CommonModule],
  imports: [TranslateModule, NgIf, MatProgressSpinnerModule, MatStepperModule, DatePipe, NgForOf, MatExpansionModule],
  templateUrl: './track-order.component.html'
})
export class TrackOrderComponent implements OnInit {
  loading = true;
  orderId!: string;
  details!: any;
  lang = localStorage.getItem('language') || 'ar';
  constructor(
    private activatedRoute: ActivatedRoute,
    private service: ResAnonymousService,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe(params => {
      if (params.get('id')) {
        this.orderId = params.get('id') || '';
      }
      if (this.orderId) {
        this.ResAnonymousTakeawayOrderStatus();
      }
    });
  }

  ResAnonymousTakeawayOrderStatus() {
    this.loading = true;
    this.service.ResAnonymousTakeawayOrderStatus(this.orderId)
      .subscribe(resp => {
        this.loading = false;
        this.details = resp;
      }, err => {
        this.loading = false;
      });
  }
}
